// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"1387":"da56ad33","9960":"c02557fa"}[chunkId] + ".chunk.min.js";
};